import './css/index.css';

import React from 'react'
import { connect } from 'react-redux';
import $ from 'jquery';
import Bowser from 'bowser';
import FileSaver from 'file-saver';
import JsExcelTemplate from 'js-excel-template/js-excel-template.min.js';
import Glkit from '@3d-smile/glkit';
import Loader from '@xgk/js-web-loader';

import { runViewer } from './js/index';

import { API_GET_JOB_ASSETS, API_NEXT_STEP, API_SEND_COMMENT } from '../../config';
import { switch_api } from '../../actions/switch_api';

class Viewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  nextStep() {
    let token =  localStorage.getItem('token');

    return fetch(switch_api(API_NEXT_STEP(this.props.match.params.uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_NEXT_STEP }: ${response.statusText}`);
        this.setState({loading:false});
      }
      
      window.location = '/home';
    })
    .catch((e) => {
      console.warn(e);
      // this.setState({loading:false});
    })
  }

  comment(comment, cb) {
    let token =  localStorage.getItem('token');
    return fetch(switch_api(API_SEND_COMMENT(this.props.match.params.uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({ comment })
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_SEND_COMMENT }: ${response.statusText}`);
        this.setState({loading:false});
      } else {
        cb();
      }
    })
    .catch((e) => {
      console.warn(e);
      // this.setState({loading:false});
    })
  }

  getJobAssets() {
    fetch(switch_api(API_GET_JOB_ASSETS(this.props.match.params.uuid)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${ localStorage.getItem('token') }`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
      .then((response) => {
        if (!response.ok) {
          console.error(`Failed loading { API_GET_JOB_ASSETS }: ${response.statusText}`);
        }
        return response;
      })
      .then((response) => response.json())
      .then((json) => {
        runViewer({
          case_json: json['case.json'],
          pdf: json.pdf,
          patient_tag: json.patient_tag,
          libs: { $, Bowser, FileSaver, JsExcelTemplate, Glkit, Loader },
          nextStep: () => this.nextStep(),
          comment: (data, cb) => this.comment(data, cb),
        });
      })
      .catch((evt) => {
        // window.location = '/home';
        console.error(evt);
      });
  }

  componentDidMount() {
    this.getJobAssets();
  }

  render() {
    return (
      <div className='_3d_plan-wrapper' id='_3d_plan-wrapper' draggable='false'>
        <div className='_3d_plan-wrapper-screen_flag' id='_3d_plan-wrapper-screen_flag' draggable='false' />
        <div className='_3d_plan-canvas' id='_3d_plan-canvas' draggable='false' />
        <div className='_3d_plan-controls' id='_3d_plan-controls' draggable='false'>
          <div className='_3d_plan-controls-button' id='_3d_plan-controls-button' draggable='false'>
            <img width='100%' height='100%' draggable='false' />
          </div>
          <div className='_3d_plan-controls-actions-logo' id='_3d_plan-controls-actions-logo' draggable='false'>
            <img width='100%' height='100%' draggable='false' />
          </div>
          <div className='_3d_plan-controls-actions' id='_3d_plan-controls-actions' draggable='false'>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-both' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-occlusion' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-upper' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-lower' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-grid' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-separations' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-locks' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-pdf' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
            <div className='_3d_plan-controls-actions-cell' id='_3d_plan-controls-actions-cell-info' draggable='false'>
              <img width='100%' height='100%' draggable='false' />
            </div>
          </div>
        </div>
        <div className='_3d_plan-info' id='_3d_plan-info' draggable='false'>
          <div className='_3d_plan-info-inner' draggable='false'>
            <div className='_3d_plan-info-title' id='_3d_plan-info-title' draggable='false'>
              <span />
            </div>
            <div className='_3d_plan-info-upper' id='_3d_plan-info-upper' draggable='false'>
              <p />
            </div>
            <div className='_3d_plan-info-lower' id='_3d_plan-info-lower' draggable='false'>
              <p />
            </div>
            <div className='_3d_plan-info-actions' id='_3d_plan-info-actions' draggable='false'>
              <a className='_3d_plan-info-actions-publish' id='_3d_plan-info-actions-publish' draggable='false' />
              <a className='_3d_plan-info-actions-rework' id='_3d_plan-info-actions-rework' draggable='false' />
            </div>
            <div className='_3d_plan-info-debug' id='_3d_plan-info-debug' draggable='false' />
            <div className='_3d_plan-info-close' id='_3d_plan-info-close' draggable='false'>
              <div>+</div>
            </div>
            <div className='_3d_plan-info-occlusion' id='_3d_plan-info-occlusion' draggable='false'>
              <img className='_3d_plan-info-occlusion-en' id='_3d_plan-info-occlusion-en' width='100%' height='100%' draggable='false' />
              <img className='_3d_plan-info-occlusion-ru' id='_3d_plan-info-occlusion-ru' width='100%' height='100%' draggable='false' />
            </div>
          </div>
        </div>
        <div className='_3d_plan-sequencer' id='_3d_plan-sequencer' draggable='false'>
        <div className='_3d_plan-sequencer-upper_title' id='_3d_plan-sequencer-upper_title' draggable='false'>
          <span />
          <span />
        </div>
        <div className='_3d_plan-sequencer-lower_title' id='_3d_plan-sequencer-lower_title' draggable='false'>
          <span />
          <span />
        </div>
          <div className='_3d_plan-sequencer-container' draggable='false'>
            <div className='_3d_plan-sequencer-actions' draggable='false'>
              <div className='_3d_plan-sequencer-cell' draggable='false' unselectable='on'>
                <div className='_3d_plan-sequencer-button' id='_3d_plan-sequencer-button-first_step' draggable='false' unselectable='on'>
                  <img draggable='false' unselectable='on'/>
                </div>
              </div>
              <div className='_3d_plan-sequencer-cell' draggable='false' unselectable='on'>
                <div className='_3d_plan-sequencer-button' id='_3d_plan-sequencer-button-pause' draggable='false' unselectable='on'>
                  <img draggable='false' unselectable='on'/>
                </div>
              </div>
              <div className='_3d_plan-sequencer-cell' draggable='false' unselectable='on'>
                <div className='_3d_plan-sequencer-button' id='_3d_plan-sequencer-button-play' draggable='false' unselectable='on'>
                  <img draggable='false' unselectable='on'/>
                </div>
              </div>
              <div className='_3d_plan-sequencer-cell' draggable='false' unselectable='on'>
                <div className='_3d_plan-sequencer-button' id='_3d_plan-sequencer-button-last_step' draggable='false' unselectable='on'>
                  <img draggable='false' unselectable='on'/>
                </div>
              </div>
            </div>
            <div className='_3d_plan-sequencer-track' id='_3d_plan-sequencer-track' draggable='false' />
            <div className='_3d_plan-sequencer-runner' id='_3d_plan-sequencer-runner' draggable='false' />
          </div>
        </div>
        <div className='_3d_plan-comment' id='_3d_plan-comment' draggable='false'>
          <textarea className='_3d_plan-comment-text' id='_3d_plan-comment-text' draggable='false' />
          <div className='_3d_plan-comment-actions' id='_3d_plan-comment-actions' draggable='false'>
            <a className='_3d_plan-comment-actions-send -disabled' id='_3d_plan-comment-actions-send' draggable='false' />
            <a className='_3d_plan-comment-actions-cancel' id='_3d_plan-comment-actions-cancel' draggable='false' />
          </div>
        </div>
        <div className='_3d_plan-nowebgl' id='_3d_plan-nowebgl' draggable='false' />
        <div className='_3d_plan-loader' id='_3d_plan-loader' draggable='false'>
          <div className='_3d_plan-loader-inner' draggable='false'><svg width='100' height='100' draggable='false'><circle id='_3d_plan-loader-circle' cx='50' cy='50' r='45' draggable='false' /></svg>
            <div className='_3d_plan-loader-percentage' id='_3d_plan-loader-percentage' draggable='false'>0%</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ user }) => ({ user }))(Viewer);



// WEBPACK FOOTER //
// ./src/views/ViewerV4/plan-standart.jsx